import { WithLangs } from '@common/typescript/objects/Page';
import { Lang } from '@common/typescript/objects/Lang';
import { capitalizeFirstLetter } from '@common/react/utils/utils';

import { NTPage, PageInfo } from '@commonTuna/react/objects/Page';

export const sliderSettings = {
	dots: false,
	infinite: true,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 4000,
	swipeToSlide: true,
	responsive: [
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
			},
		},
	],
};

export const reviewsSliderSettings = {
	...sliderSettings,
	slidesToShow: 3,
	adaptiveHeight: false,
	responsive: [
		{
			breakpoint: 1200,
			settings: {
				slidesToShow: 2,
			},
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
			},
		},
	],
};

export const getPageInfo = (item: WithLangs<PageInfo>, lang: Lang): PageInfo | undefined => {
	return item.langs.length > 0 ? (item.langs.find((langItem) => langItem.language === lang) || item.langs[0]) : undefined;
};

export const getPageShortName = (item: NTPage, lang: Lang): string => {
	return lang === Lang.Es
		? item?.shortNameEs || item?.shortNameEn || item?.name
		: item?.shortNameEn || item?.shortNameEs || item?.name;
};

export const getLangByName = (language: string): Lang => {
	return (Lang[capitalizeFirstLetter(language.toLowerCase())] || Lang.En) as Lang;
};

export const selectProps = {
	theme: (theme) => ({
		...theme,
		colors: {
			...theme.colors,
			primary25: 'rgba(255, 255, 255, 0.3)',
			primary: 'rgba(238, 174, 21, 0.5)',
		},
	}),
	styles: {
		option: (base, state) => ({
			...base,
			color: state.isSelected ? '#fff !important' : 'inherit',
			backgroundColor: state.isSelected ? '#5a4a2f' : 'inherit',
		}),
	},
};
